"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _jquery = _interopRequireDefault(require("jquery"));

var _style = _interopRequireDefault(require("./style.css"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/** cccisd-hidden-block provides your with the block which shows up after clicking a link */
var _default =
/*#__PURE__*/
function (_React$Component) {
  _inherits(_default, _React$Component);

  function _default() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, _default);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(_default)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "state", {
      show: _this.props.show
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "setShow", function (show) {
      _this.setState({
        show: show
      });
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "_clicked", function (e) {
      e.preventDefault();
      (0, _jquery.default)(_this.refs.link).blur();

      if (_this.props.handleClick) {
        _this.props.handleClick(!_this.props.show);
      } else {
        _this.setState({
          show: !_this.state.show
        });
      }
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "_isShow", function () {
      if (_this.props.handleClick) {
        return _this.props.show;
      }

      return _this.state.show;
    });

    return _this;
  }

  _createClass(_default, [{
    key: "render",
    value: function render() {
      var body = null;

      if (this._isShow()) {
        body = _react.default.createElement("div", {
          className: _style.default.body_wrapper
        }, this.props.children);
      }

      var arrowClassName = this._isShow() ? 'glyphicon glyphicon-triangle-bottom' : 'glyphicon glyphicon-triangle-right';
      return _react.default.createElement("div", null, _react.default.createElement("span", {
        className: _style.default.arrow_wrapper
      }, _react.default.createElement("span", {
        className: arrowClassName
      })), _react.default.createElement("a", {
        href: "#",
        onClick: this._clicked,
        className: _style.default.link,
        ref: "link"
      }, this.props.title), this.props.comment, body);
    }
  }]);

  return _default;
}(_react.default.Component);

exports.default = _default;

_defineProperty(_default, "propTypes", {
  /** Title of the link */
  title: _propTypes.default.node,

  /** Comment/text shown after link is clicked. */
  comment: _propTypes.default.node,

  /** Show the hidden block or not. <br> This prop depends on the handleClick prop: <br> If handleClick is null then it will be the default value. <br> If handleClick is a function then it will be the actual value. */
  show: _propTypes.default.bool,

  /** Callback function that runs when clicking the link. */
  handleClick: _propTypes.default.func,
  children: _propTypes.default.node
});

_defineProperty(_default, "defaultProps", {
  title: 'Hidden block',
  comment: null,
  show: false,
  handleClick: null
});